import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from "react-redux";
import * as commonActions from '../../../../../app/common/common.action';
import { ModalObservacoesPage } from './modal.observacoes.page';
import WebapiCommon from '../../../../../app/common/util/webapi.common';

class ModalObservacoesContainer extends Component {
    constructor() {
        super();
        this.state = {
            texto: "",
        }
    }

    componentDidMount() {
        WebapiCommon.getObservacaoLaudo(this.props.item.laudo).then(textoResponse => {
            this.setState({
                texto: textoResponse,
            })
        });
    }

    render() {
        return (
            <ModalObservacoesPage
                openModal={this.props.modalObservacoes}
                modalOnChangeTexto={this.modalOnChangeTexto.bind(this)}
                atualizaObservacoes={this.atualizaObservacoes.bind(this)}
                altura={parseInt(this.props.altura, 10) - 30}
                item={this.props.item}
                texto={this.state.texto}
                closeModal={this.closeModal.bind(this)}
            />
        )
    }

    atualizaObservacoes() {
        this.props.commonActions.showFadeCarregando(true);
        WebapiCommon.atualizarObservacoesLaudo(this.props.item.laudo, this.state.texto).then((Response) => {
            this.props.commonActions.showFadeCarregando(false);
            this.props.commonActions.showAlerta("sucesso", "Observação gravada com sucesso!", 1500);
            this.props.commonActions.mudarStatusModalObservacoes(false, undefined);
        });
    }

    modalOnChangeTexto(value) {
        this.setState({
            texto: value
        });
    }

    closeModal() {
        this.props.commonActions.mudarStatusModalObservacoes(false, undefined);
        this.setState({
            texto: "",
        })
    }
}


const mapStateToProps = (state) => {
    return {
        modalObservacoes: state.commonReducer.modalObservacoes,
        item: state.commonReducer.laudo,
    }
}

const mapDispacthToProps = (dispatch) => {
    return {
        commonActions: bindActionCreators(commonActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispacthToProps)(ModalObservacoesContainer);


// WEBPACK FOOTER //
// ./src/pages/main/listagem/modais/observacoes/modal.observacoes.container.js